export default __webpack_public_path__ + "static/img/img_rjzzq.508c761.png";